import { cn } from '../../lib/format.js';

/**
 * A five-star rating. Rendered as one SVG with a clipped overlay rather than
 * five half-star glyphs, so 4.3 looks like 4.3 rather than being rounded to
 * something the average does not say.
 */
export const Rating = ({ value = 0, count, size = 'sm', showCount = true, className }) => {
  const dimension = size === 'lg' ? 'size-4' : 'size-3';
  const percent = Math.max(0, Math.min(100, (value / 5) * 100));

  const star = (
    <path d="M8 1.6l1.9 3.86 4.26.62-3.08 3 .73 4.24L8 11.32l-3.81 2 .73-4.24-3.08-3 4.26-.62z" />
  );

  return (
    <div className={cn('flex items-center gap-1.5', className)}>
      <span
        className="relative inline-flex shrink-0"
        role="img"
        aria-label={count ? `${value} out of 5, ${count} reviews` : `${value} out of 5`}
      >
        <span className="flex gap-0.5 text-mist">
          {Array.from({ length: 5 }, (_, index) => (
            <svg key={index} viewBox="0 0 16 16" fill="currentColor" className={dimension} aria-hidden="true">
              {star}
            </svg>
          ))}
        </span>
        <span
          className="absolute inset-0 flex gap-0.5 overflow-hidden text-accent"
          style={{ width: `${percent}%` }}
          aria-hidden="true"
        >
          {Array.from({ length: 5 }, (_, index) => (
            <svg key={index} viewBox="0 0 16 16" fill="currentColor" className={cn(dimension, 'shrink-0')}>
              {star}
            </svg>
          ))}
        </span>
      </span>

      {showCount && count > 0 && (
        <span className="font-mono text-2xs text-muted" data-numeric>
          {value.toFixed(1)} ({count})
        </span>
      )}
    </div>
  );
};

export default Rating;
